import { timelineSteps } from "@/mocks/homeData";

export default function CaseTimeline() {
  return (
    <section id="timeline" className="relative overflow-hidden">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-medium uppercase tracking-widest text-primary-600">进展时间线</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一个热曝的「标准爆发节奏」，长什么样
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              以一条典型事件为例，看它如何经历当事人是谁的追问、身份起底、背景深扒，再到关联人物与旧料翻出、澄清与归档。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-sm text-secondary-600">
            <i className="ri-article-line text-accent-600" />
            示意样本 · 便于理解传播节奏
          </span>
        </div>

        <div className="relative mt-10">
          <span className="absolute left-4 top-0 h-full w-px bg-secondary-200 lg:left-1/2 lg:-translate-x-1/2" />

          <div className="space-y-6 lg:space-y-0">
            {timelineSteps.map((step, i) => {
              const left = i % 2 === 0;
              return (
                <div key={step.time} className="relative lg:mb-6 lg:grid lg:grid-cols-2 lg:gap-12">
                  <span
                    className={`absolute left-4 top-5 z-10 flex h-4 w-4 -translate-x-1/2 items-center justify-center rounded-full ring-4 ring-background-50 lg:left-1/2 ${
                      i === timelineSteps.length - 1 ? "bg-accent-500" : "bg-primary-500"
                    }`}
                  />
                  <div className={`pl-10 lg:pl-0 ${left ? "lg:pr-2 lg:text-right" : "lg:col-start-2 lg:pl-2"}`}>
                    <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-4 transition-colors hover:border-primary-200 md:p-5">
                      <div
                        className={`flex flex-wrap items-center gap-2 ${left ? "lg:justify-end" : ""}`}
                      >
                        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-900">
                          <i className="ri-time-line" />
                          {step.time}
                        </span>
                        <span className="inline-flex items-center rounded-md bg-secondary-200 px-2 py-0.5 text-xs text-secondary-900">
                          {step.type}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold text-foreground-900 md:text-lg">
                        {step.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}